import { useCallback } from 'react';
import { useNavigate } from 'react-router';
import { routes } from 'routes/routes';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- TODO: fix according to result of #67489
import type { OrganizationEntityType } from 'features/organizations/models';

export const useNavigateToOrganizationEntity = () => {
  const navigate = useNavigate();

  return useCallback(
    async (organizationId: string, scope: OrganizationEntityType) => {
      await navigate(routes.organization.entities(organizationId, scope));
    },
    [navigate],
  );
};
